// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Gift';

export function Gift() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={TITLE}
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5179 6.25172C11.1965 6.18625 11.4014 5.95443 11.4449 5.86581C11.4884 5.77719 11.5424 5.48119 11.1513 4.96062C10.7815 4.46843 10.1189 3.94521 9.22856 3.56643C8.33825 3.18765 7.47969 3.06367 6.83808 3.12558C6.15948 3.19105 5.95458 3.42286 5.9111 3.51149C5.86762 3.60011 5.81358 3.8961 6.20467 4.41667C6.57444 4.90886 7.23712 5.43209 8.12743 5.81087C9.01773 6.18965 9.87629 6.31362 10.5179 6.25172ZM12.2108 6.49999C12.2173 6.49181 12.2238 6.48357 12.2301 6.47526C12.2364 6.48357 12.2429 6.49181 12.2494 6.49999H12.2108ZM7.23975 6.49999C5.47818 5.60218 4.48497 4.15127 4.99092 3.12C5.53824 2.00438 7.63269 1.80231 9.66901 2.66865C10.8824 3.18488 11.8013 3.96397 12.2301 4.74539C12.6589 3.96397 13.5778 3.18488 14.7912 2.66865C16.8275 1.80231 18.922 2.00438 19.4693 3.12C19.9752 4.15127 18.982 5.60218 17.2205 6.49999H22V11.5H20V21.5H3.9V11.5H2V6.49999H7.23975ZM13.9423 6.25172C13.2637 6.18625 13.0588 5.95443 13.0153 5.86581C12.9718 5.77719 12.9178 5.48119 13.3089 4.96062C13.6787 4.46843 14.3413 3.94521 15.2316 3.56643C16.122 3.18765 16.9805 3.06367 17.6221 3.12558C18.3007 3.19105 18.5056 3.42286 18.5491 3.51149C18.5926 3.60011 18.6466 3.8961 18.2555 4.41667C17.8858 4.90886 17.2231 5.43209 16.3328 5.81087C15.4425 6.18965 14.5839 6.31362 13.9423 6.25172ZM4.9 20.5V11.5H9.07102V20.5H4.9ZM9.07102 7.49999V10.5H3V7.49999H9.07102ZM10.071 20.5V7.49999H13.929V20.5H10.071ZM14.929 10.5V7.49999H21V10.5H14.929ZM14.929 20.5V11.5H19V20.5H14.929Z"
        fill="currentColor"
      />
    </svg>
  );
}
